import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { firstValueFrom } from 'rxjs';
import { take } from 'rxjs/operators';

// This guard checks if the user has API_ACCESS permission
export const BulkUserUpdateGuard = async () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Get current permissions (wait for first emission)
  const permissions = await firstValueFrom(authService.permissions$.pipe(take(1)));

  // Check if user has API_ACCESS permission
  const hasApiAccess = permissions?.API_ACCESS === 1;

  if (hasApiAccess) {
    return true;
  }

  return router.parseUrl('/dashboard');
};
